import React from "react";
import timeFunction from "../../functions/getTime";
import getVideoImage from "../../functions/getImage";

export default function ImageCard(props) {
  function openLink() {
    if (props.data && props.isVideo) {
      window.open(
        `/${props.lang}/video/${props.data.slug}`,
        "_self"
      );
    } else {
      window.open(
        `/${props.lang}/gallery/${props.data.slug}`,
        "_self"
      );
    }
  }

  return (
    // pt-[40px] เผื่อที่ให้รูปซ้อนที่ยื่นขึ้นไป 40px จะได้ไม่ทับข้อความของการ์ดแถวบน
    // flex-col + mt-auto ทำให้บรรทัด วันที่/แสดงภาพ อยู่ล่างสุดตรงกันทุกใบในแถว
    // ทั้งการ์ดคลิกได้ (รูป ชื่อ วันที่ แสดงภาพ) ไม่ต้องเล็งจุดใดจุดหนึ่ง
    <div className="image-card h-full flex flex-col pt-[40px] cursor-pointer" onClick={() => openLink()}>
      {props.isVideo !== true ? (
        <div className="relative ml-[40px]">
          <div
            className="cursor-pointer z-20 absolute top-[-40px] right-[40px] h-[200px] w-full rounded-[12px] bg-lightGray !bg-cover !bg-center"
            style={
              props.data &&
              props.data.image.image &&
              props.data.image.image
                ? {
                    background: `url(${process.env.REACT_APP_API_URL}${props.data.image.image[0].url})`,
                  }
                : { background: `#D9D9D9` }
            }
          />
          <div className="cursor-pointer z-10 absolute top-[-20px] right-[20px] h-[200px] w-full rounded-[12px] bg-lightGray2 !bg-cover !bg-center" />
          <div className="cursor-pointer z-30 h-[200px] rounded-[12px] bg-darkGray w-full !bg-cover !bg-center" />
        </div>
      ) : (
        <div>
          <div
            className="cursor-pointer h-[200px] rounded-[12px] bg-lightGray w-full !bg-cover !bg-center"
            style={{
              background:
                props.data &&
                `url(${getVideoImage(props.data.video[0].href)}), #D9D9D9`,
            }}
          />
        </div>
      )}

      {props.data && (
        <p className="font-medium mt-[15px] text-body text-left line-clamp-2">
          {props.lang === "th"
            ? props.data.title.detail_TH
            : props.data.title.detail_EN}
        </p>
      )}

      <div className="mt-auto pt-[15px] flex justify-between items-center gap-[16px]">
        <p className="text-small font-medium text-left">
          {timeFunction.getDay(props.data.date, props.lang)}
        </p>
        <p className="text-small font-bold text-right text-brand hover:opacity-80 transition-opacity whitespace-nowrap">
          {props.lang === "th" ? "แสดงภาพ" : "See more"}
        </p>
      </div>
    </div>
  );
}
